import { defineComponent as _defineComponent } from 'vue'
import { useBreakpointsStore } from "@/stores/breakpoints";
import { useProtestEventsStore } from "@/stores/protest-events";
import { ref } from "vue";
import { useRoute } from "vue-router/composables";
import TheNavBarMobileDrawer from "./TheNavBarMobileDrawer.vue";

interface Menu {
  text: string;
  link: object;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavBar',
  setup(__props) {

const protestEventStore = useProtestEventsStore();
const breakpointStore = useBreakpointsStore();

const route = useRoute();
const drawer = ref<boolean>(false);

const links = ref<Menu[]>([
  {
    text: "Bundesweit",
    link: { name: "NationalAnalysis" },
  },
  {
    text: "Städte",

    link: {
      name: "LocalAnalysis",
      query: { stadt: protestEventStore.cities[0].label },
    },
  },
  {
    text: "Methoden",
    link: { name: "Methods" },
  },
  {
    text: "Kontakt",
    link: { name: "Contact" },
  },
]);

return { __sfc: true,protestEventStore, breakpointStore, route, drawer, links, TheNavBarMobileDrawer }
}

})